import type { Service } from '@/features/services/types'

export function getServiceStatusBadgeClass(status: Service['status']): string {
  switch (status) {
    case 'published':
      return 'bg-green-100 text-green-800'
    case 'draft':
      return 'bg-yellow-100 text-yellow-800'
    case 'archived':
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

export interface ServicePreviewMetadata {
  heroImage?: string
  heroHeadline?: string
  description?: string
  badges: Array<{ label: string; className?: string; variant?: 'outline' | 'secondary'; icon?: 'star' }>
  benefits: NonNullable<Service['benefits']>
  processSteps: NonNullable<Service['process_steps']>
  faqs: NonNullable<Service['faqs']>
}

export function buildServicePreviewMetadata(service: Service): ServicePreviewMetadata {
  const badges: ServicePreviewMetadata['badges'] = [
    { label: service.status, className: getServiceStatusBadgeClass(service.status) }
  ]

  if (service.is_featured) badges.push({ label: 'Featured', variant: 'outline', icon: 'star' })
  if (service.is_footer_service) badges.push({ label: 'Footer Service', variant: 'outline' })
  if (service.category) badges.push({ label: service.category, variant: 'secondary' })

  const legacyFaqs = (service.faq || []).map((faq, index) => ({
    id: `faq-${index}`,
    question: faq.question,
    answer: faq.answer,
  }))

  return {
    heroImage: service.hero_image,
    heroHeadline: service.hero_headline,
    description: service.description,
    badges,
    benefits: service.benefits || [],
    processSteps: service.process_steps || [],
    faqs: service.faqs || legacyFaqs,
  }
}
